module.exports = __webpack_public_path__ + "img/375.28515b6b.jpg";